export const settingsDv = {
  beginToken: '81162727-7245-4058-88b0-38db22f8737f',
  name: 'dev',
  baseUrl: 'https://dsi-se-residuedef-func-dev.azurewebsites.net/api/',
  authority: 'https://login.microsoftonline.com/3e20ecb2-9cb0-4df1-ad7b-914e31dcdda4',
  clientID: 'dfd9be2e-1608-498e-9610-09e62fdfdeb2',
  redirectUri: 'https://dsi-se-residuedef-app-dev.azurewebsites.net/',
  key1: 'https://graph.microsoft.com/v1.0/me',
  key2: 'https://dsi-se-residuedef-func-dev.azurewebsites.net/api/',
  key3: 'https://graph.microsoft.com/v1.0/users',
  value1: ['user.read'],
  value2: ['https://agcompany.onmicrosoft.com/residuedefinition/test/user_impersonation/AccessResidueDefinitionQa'],
  value3: ['user.read.all'],

  msalAngular: {
    consentScopes: [
      'https://analysis.windows.net/powerbi/api/Report.Read.All',
      'https://agcompany.onmicrosoft.com/residuedefinition/test/user_impersonation/AccessResidueDefinitionQa',
      'User.Read', 'User.ReadBasic.All', 'profile', 'openid'
    ],
    unprotectedResources: ['version.json']
  },

  SUPPORT_BOT_SETTINGS: {
    botAlias: "$LATEST",
    botName: "TesterBOT",
    supportName: "DSI Support",
    roleArn: "arn:aws:iam::074443567659:role/dsi_dv-lexrole-sts",
    roleSessionName: "DvSession"
  },

  powerBiConsentScope: 'https://analysis.windows.net/powerbi/api/Report.Read.All',
  powerBiReportEmbedUrl: 'https://app.powerbi.com/reportEmbed',
  powerBiReportId: '',
  powerBiGroupId: '',
  netDocsScope: 'api://43aeb1a0-45c5-4687-8c0c-b35db02570f0/nd_access',
  netDocsUrl: 'https://8be6w9m8ja.execute-api.us-east-1.amazonaws.com/dv/v1/lambda/v1',
  netDocsCabinet: 'NG-7M3XK9TA',
  appAdmin: 'Jennifer Jones',
  functionScope: 'https://agcompany.onmicrosoft.com/residuedefinition/test/user_impersonation/AccessResidueDefinitionQa',
  ServiceUrl: 'https://dsi-se-residuedef-func-dev.azurewebsites.net/',
  endToken: '4daa9ca3-3ea3-4873-82c5-168cfc5864ae'
};
